import React from 'react';

interface AvatarProps {
	src: string;
	alt: string;
	size?: 'small' | 'medium' | 'large';
}

const Avatar: React.FC<AvatarProps> = ({ src, alt, size = 'medium' }) => {
	const getSize = () => {
		switch (size) {
			case 'small':
				return { width: '30px', height: '30px' };
			case 'large':
				return { width: '50px', height: '50px' };
			default:
				return { width: '40px', height: '40px' };
		}
	};

	const style = {
		borderRadius: '50%',
		overflow: 'hidden',
		...getSize()
	};

	return (
		<div
			className="avatar"
			style={style}>
			<img
				src={src || 'https://via.placeholder.com/40'}
				alt={alt}
				style={{ width: '100%', height: '100%', objectFit: 'cover' }}
			/>
		</div>
	);
};

export default Avatar;
